<router-outlet></router-outlet>
<fibr-toast />
<p-confirmDialog [style]="{ 'min-width': '300px' }"></p-confirmDialog>
